import "react";
import { jsx as e } from "react/jsx-runtime";
//#region src/components/atoms/Icon/SVGs/check.svg
var t = (t) => /* @__PURE__ */ e("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 16 16",
	...t,
	children: /* @__PURE__ */ e("path", {
		fill: "currentColor",
		d: "M15.113.675a.94.94 0 0 0-1.31.216L5.028 13.128l-2.93-2.932A.938.938 0 1 0 .77 11.522l3.712 3.71a.953.953 0 0 0 1.425-.115l9.422-13.133a.94.94 0 0 0-.216-1.309"
	})
});
//#endregion
export { t as default };
